import moment from 'moment';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';

export default function decorateurRectangleNumeriqueChildReseau(result, reseau) {
  result.line = 0;
  result.key = moment(reseau.dateDebut).format('YYYYMMDD');
  result.label = reseau.resLibelle;
  result.fill = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectangleNumeriqueChildReseau.js